import styled from "styled-components";
import {schemas} from "../../config";
import {useAppDispatch, useAppSelector} from "../../hooks";
import {useEffect, useRef} from "react";
import {
    ManageSchemaFrontTableI,
    setFrontSchemaStateField, setSchemaManagePageArchiveOpen,
    setSchemaManageSelectedFacet
} from "../../features/schemaManageSlice";
import FrontTableSchemaManage from "./front/FrontTableSchemaManage";
import useLoadManageSchema from "../hooks/useLoadManageSchema";
import BackSchemaManage from "./back/BackSchemaManage";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDownUpAcrossLine} from "@fortawesome/free-solid-svg-icons";
import useDimensions from "../hooks/useDimensions";
import Loader from "../Loader";
import ArchiveViewer from "./ArchiveViewer";
import {setViewportWidth} from "../../features/layoutSlice";


export default function SchemaManagePage({projectName}: { projectName: string }) {

    const selectedTable = useAppSelector(state => state.schemaManage.front.selectedTable);
    const selectedFacet = useAppSelector(state => state.schemaManage.selectedFacet);
    const isArchiveOpen = useAppSelector(state => state.schemaManage.archiveOpen);
    const dispatch = useAppDispatch();
    const schema = schemas[projectName]


    useEffect(() => {
        if (!schema)
            return
        if (!selectedTable) {
            const initialState = {} as { [key: string]: ManageSchemaFrontTableI }
            Object.keys(schema.tables).forEach(name => {
                initialState[name] = {
                    fields: {
                        mode: "view",
                    },
                    filters: {
                        mode: "view",
                    },
                    main: {
                        mode: "view",
                    },
                    data: schema.tables[name]
                } as ManageSchemaFrontTableI
            });
            dispatch(setFrontSchemaStateField("tables", initialState))
            dispatch(setFrontSchemaStateField("selectedTable", schema.defaultTable))

        }
    }, [dispatch, schema, selectedTable]);

    const isStateLoaded = useLoadManageSchema(projectName, schema?.backend ?? null, !!selectedTable)

    let ref = useRef<null | HTMLElement>(null);
    let {width} = useDimensions(ref);



    if (!isStateLoaded || width <= 0)
        return <Container style={{height: "calc(100vh - var(--header-height)"}}>
            <Loader/>
        </Container>

    return <Container ref={ref}>
        <button className={'toggle-facet btn-cmn'}
                onClick={() => dispatch(setSchemaManageSelectedFacet(selectedFacet === "front" ? "back" : "front"))}>
            <FontAwesomeIcon icon={faArrowDownUpAcrossLine} className={'fa-secondary-color-text'}/>
            {selectedFacet === "front" ? "FRONT" : "BACK"}
            <FontAwesomeIcon icon={faArrowDownUpAcrossLine} className={'fa-secondary-color-text'}/>
        </button>
        {selectedFacet === "back" &&
            <button className={'btn-cmn'} onClick={() => dispatch(setSchemaManagePageArchiveOpen(true))}>
                АРХІВ
            </button>}
        {selectedFacet === "front" && <FrontTableSchemaManage width={width} projectName={projectName}/>}
        {selectedFacet === "back" && <BackSchemaManage projectName={projectName}/>}
        {isArchiveOpen && <ArchiveViewer/>}
    </Container>
}


const Container = styled.section`

    display: flex;
    flex-flow: column;
    gap: .5rem;
    justify-content: center;

    line-height: 1.2;

    background-color: hsl(from var(--table-row-odd-bg-color) h s l / 0.6);
    color: var(--table-row-text-color);
    //color: hotpink;
    padding: .5rem;

    .toggle-facet {

    }


`
